import Input from './Input';
import TextArea from './TextArea';
import Instructions from './Instructions';
import DateField from './Date';
import RadioBox from './RadioBox';
import Checkbox from './Checkbox';
import Checkboxes from './Checkboxes';
import SelectField from './SelectField';
import Upload from './Upload';
import QuantityField from './QuantityField';
import Subscription from './Subscription';
import TpegTitle from './TpegTitle';
import Surcharge from './Surcharge';
import PasswordField from './PasswordField';
import Handling from './Handling';
import CreditField from './Credit';

export default {
  Input: Input,
  Email: Input,
  TextArea: TextArea,
  Instructions: Instructions,
  Date: DateField,
  Radio: RadioBox,
  Checkbox: Checkbox,
  MultiCheckbox: Checkboxes,
  Select: SelectField,
  Upload: Upload,
  Quantity: QuantityField,
  Subscription: Subscription,
  TpegTitle: TpegTitle,
  Surcharge: Surcharge,
  Password: PasswordField,
  Handling,
  Notes: Input,
  NotesRadio: RadioBox,
  Credit: CreditField
};
